module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hla_information":"HLA Information","typing":"Typing","antibodies":"Antibodies","serum_summary&review":"Serum Summary & Review","virtual_crossmatch":"Virtual Crossmatch"},"fr":{"hla_information":"Informations HLA","typing":"Typage","antibodies":"Anticorps","serum_summary&review":"Résumé et examen de sérum","virtual_crossmatch":"Compatilbilité croisée virtuelle"}}')
  delete Component.options._Ctor
}
